<template>
  <div class="footer">
    <div class="item" v-if="adTag2">
      <!--      合作站点-->
      <div class="tCenter w1000 wauto hauto mb30">
        <div class="picBox"><ul>
          <li><a href="http://photo.china.com.cn/node_7246848.htm">
            <img src="http://images.china.cn/attachement/jpg/site1000/20170414/0019b91ec9231a5aa9e901.jpg" border="0" width="111" height="60"></a></li>
          <li><a href="http://v.china.com.cn/travel/2018-10/30/content_69087633.htm">
            <img src="http://images.china.cn/site1000/2015-05/15/86e375bd-39e1-47c4-bc8e-9d8939c90517.jpg" border="0" width="111" height="60"></a></li>
          <li><a href="http://www.nanjing.gov.cn/">
            <img src="http://images.china.cn/attachement/jpg/site1000/20150515/0019b91ec92316bfd6af07.jpg" border="0" width="111" height="60"></a></li>
            <li><a href="http://www.cpcrugao.cn/"><img src="http://images.china.cn/attachement/jpg/site1000/20150515/0019b91ec92316bfd64806.jpg" border="0" width="111" height="60"></a></li><li><a href="http://yixing.china.com.cn"><img src="http://images.china.cn/attachement/jpg/site1000/20150812/d02788e9b25b173500f001.jpg" border="0" width="111" height="60"></a></li><li><a href="http://www.xz.gov.cn/"><img src="http://images.china.cn/site1000/2015-05/15/d02788e9b25b1a3f2b0e03.jpg" border="0" width="111" height="60"></a></li><li><a href="http://union.china.com.cn/zhuanti/node_1002069.htm"><img src="http://images.china.cn/site1000/2015-05/15/dca6a020-380d-4617-9d7f-6885105b04be.jpg" border="0" width="111" height="60"></a></li><li><a href="http://nanning.china.com.cn/"><img src="http://images.china.cn/attachement/jpg/site1000/20150515/0019b91ec92316bfd30201.jpg" border="0" width="111" height="60"></a></li></ul></div>
      </div>
    </div>
    <p class="bah">
      <a href="http://beian.miit.gov.cn/" target="_blank"> <img src="http://images.china.cn/images1/ch/2018first/20180821-01.png">京ICP备20002568号</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040634" target="_blank"><img src="http://images.china.cn/images1/ch/2018first/20180821-01.png">京公网安备 11010502040634号</a>
    </p>
    <p>
      <!-- <a :href="webUrl+'/FooterLinks?nav=companyinfo'" target="_blank">公司概况</a> -->
      <a :href="'/FooterLinks?nav=rongmeiti&columnId='+columnId" target="_blank">关于我们</a>
      <a :href="'/FooterLinks?nav=0'" target="_blank">人才招聘</a>
      <a :href="'/FooterLinks?nav=1'" target="_blank">广告服务</a>
      <a :href="'/FooterLinks?nav=2'" target="_blank">合作加盟</a>
      <a :href="'/FooterLinks?nav=3'" target="_blank">平台声明</a>
    </p>
    <p>
      <a v-if="columnId=='5eb257451a760a707c12e955'" href="https://yjy.goodwebuy.cn/rmzd/bottom/book.jpg" target="_blank">出版物经营许可证</a>
      <a href="https://yjy.goodwebuy.cn/rmzd/bottom/gbdsxkz.jpg" target="_blank" >广播电视节目制作许可证：(京)字第07984号</a>
      <a href="https://yjy.goodwebuy.cn/rmzd/bottom/zzdxxkz.jpg" target="_blank">增值电信业务ICP/ISP经营许可证编号：B1-20184601,B2-20182186</a>
    </p>
    <div class="kxwz">
      <p>
        <a href="javascript:volid(0);">Copyright© 2020人民互联网电视版权所有</a>
        <!-- <a href="javascript:volid(0);">京ICP备20002568号-4</a> -->
        <a  href="https://yjy.goodwebuy.cn/rmzd/bottom/wlwhxkz.jpg" target="_blank">网络文化经营许可证：京网文〔2020〕1887-283号</a>
      </p>
    </div>
    <div class="kxwz">
      <p style="display: flex;align-items: center;justify-content: center;">
        <a href="https://www.12377.cn/" target="_blank"><img src="http://images.china.cn/images1/ch/2015first/151228-001.jpg" style="width: 230px;height: 40px;" alt=""></a>
        <a href="http://www.cyberpolice.cn/wfjb/" target="_blank">网络110报警服务</a>
        <a href="https://www.12321.cn/" target="_blank">12321垃圾信息举报中心</a>
      </p>
    </div>
  </div>
</template>

<script>
  import {webUrl} from "@/api";

  export default {
      name: "Footer",
      data () {
        return {
          webUrl,
          adTag2:false,
          routePath:'',
          columnId:''
        }
      },
      watch:{
         $route(val) {
           // console.log(val);
           this.routePath=val.path;
           //  get subColumn  ---读书频道的‘关于我们’内容判断显示
           this.columnId =val.meta.queryId;
           if(this.routePath=='/bookDetail'){
             this.columnId =val.meta.columnId;
           }
         }
      },
      created() {
        // this.columnId=this.$route.meta.queryId || this.$route.meta.columnId;
        // //  get subColumn  ---读书频道的‘关于我们’内容判断显示
        // this.columnId =this.$route.meta.queryId || this.$route.query.id?(this.$route.query.id.split('.')[0] || this.$route.query.id):'';
        // if(this.$route.path=='/bookDetail'){
        //   this.columnId =this.$route.meta.columnId;
        // }

      }

    }
</script>

<!-- <script>
  (function(){
    var bp = document.createElement('script');
    var curProtocol = window.location.protocol.split(':')[0];
    if (curProtocol === 'https'){
      bp.src = 'https://zz.bdstatic.com/linksubmit/push.js';
    }
    else{
      bp.src = 'http://push.zhanzhang.baidu.com/push.js';
    }
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(bp, s);
  })();
</script> -->

<style scoped>

  .footer {
    text-align: center;
    font-size: 14px;
    color: #333333;
    /*color: #000;*/
    padding: 30px 0;
    /* background-color: #F5F5F5; */
    background-color: #FAFBFC;
    border-top: 4px solid #f5f5f5;
  }

  .item {
    width: 1118px;
    box-sizing: border-box;
    margin: 0 auto 20px;
    background-color: #ffffff;
    position: relative;
  }

  .mb30 { margin-bottom: 30px; height: 80px; padding: 20px;
  overflow: hidden;
  }
  .wauto { margin: 0px auto; }
  * { margin: 0px; padding: 0px; }
  ul, li { list-style-type: none; }
  img {border:0;}
  .picBox { width: 963px;  text-align: center;}
  .picBox li { width:111px; float:left; margin:0 3px;}
  .tCenter { text-align: center; }

  .footer p{
    line-height: 22px;
    padding: 5px 20px;
  }

  .footer p a{
    font-size: 14px;
    padding: 0 20px;
    border-right: 0px solid #999999;
    color: #333333;
    /*color: #000;*/
    line-height: 22px;
  }
  .footer p a:last-child{
    border-right: none;
  }

  .kxwz p a{
    font-size: 14px;
    padding: 0 10px;
    border-right: 0px solid #999999;
    color: #333333;
    /*color: #000;*/
    line-height: 18px;
  }
  .kxwz p a:last-child{
    border-right: none;
  }

  .bah a img{
    position: relative;
    top: 4px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue